module.exports = __webpack_public_path__ + "img/family-tree-01.875912ea.png";